/* START_MODULE_CONTRACT
 * PURPOSE: Frontend UI module: DeleteProjectDialog.
 * SCOPE: React component or page.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-PROJECTS
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * DeleteProjectDialog - Frontend UI module: DeleteProjectDialog.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: контракты функций, парные END_METHOD, блок удаления.
 * END_CHANGE_SUMMARY
 */

import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

/* START_METHOD_DeleteProjectDialog */
/* START_CONTRACT: DeleteProjectDialog
 * PURPOSE: Диалог подтверждения удаления проекта.
 * INPUTS: { open: boolean, onClose: ()=>void, onConfirm: (id)=>Promise, project: Project }.
 * OUTPUTS: { JSX.Element|null - диалог }.
 * SIDE_EFFECTS: вызов onConfirm (HTTP наверх); локальный state.
 * LINKS: M-FE-PROJECTS
 * END_CONTRACT: DeleteProjectDialog
 */
export default function DeleteProjectDialog({ open, onClose, onConfirm, project }) {
  const [loading, setLoading] = useState(false);

  if (!project) return null;

  /* START_METHOD_handleConfirm */
  /* START_CONTRACT: handleConfirm
   * PURPOSE: Удалить проект; при успехе закрыть диалог.
   * INPUTS: {}.
   * OUTPUTS: { Promise<void> }.
   * SIDE_EFFECTS: onConfirm (HTTP); setLoading; onClose.
   * LINKS: M-FE-PROJECTS
   * END_CONTRACT: handleConfirm
   */
  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm(project.id);
      /* START_BLOCK_DELETE_OK */
      onClose();
      /* END_BLOCK_DELETE_OK */
    } finally {
      setLoading(false);
    }
  };
  /* END_METHOD_handleConfirm */

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: '1rem' }}>Удаление проекта</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Вы действительно хотите удалить проект &laquo;{project.name}&raquo;?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={handleConfirm}
          disabled={loading}
        >
          Удалить
        </Button>
        <Button size="small" onClick={onClose} disabled={loading}>
          Отмена
        </Button>
      </DialogActions>
    </Dialog>
  );
}
/* END_METHOD_DeleteProjectDialog */
